const vapeDokhaKnowledge = {

  dokha: {
    keywords: [
      "dokha",
      "strong dokha",
      "light dokha",
      "medium dokha",
      "buzz",
      "x torbo",
      "fadayee",
      "yousef redha",
      "al khumery",
      "trex"
    ],

    collections: [
      {
        name: "Dokha",
        url: "/collections/dokha"
      },

      {
        name: "X Torbo Dokha",
        url: "/collections/turbo-dokha"
      },

      {
        name: "Strong Buzz Dokha",
        url: "/collections/strong-buzz-dokha"
      },

      {
        name: "Medium Buzz Dokha",
        url: "/collections/medium-buzz-dokha"
      },

      {
        name: "Light Buzz Dokha",
        url: "/collections/light-buzz-dokha"
      }
    ]
  },

  medwakh: {

    keywords: [
      "medwakh",
      "pipe",
      "dokha pipe",
      "filter",
      "cleaner",
      "pouch"
    ],

    collections: [
      {
        name: "Medwakh",
        url: "/collections/medwakh"
      },

      {
        name: "Dokha Accessories",
        url: "/collections/dokha-acessories"
      },

      {
        name: "Medwakh Filter",
        url: "/collections/medwakh-filter"
      },

      {
        name: "Medwakh Cleaner",
        url: "/collections/medwakh-cleaner"
      }
    ]
  },

  vape: {

    keywords: [
      "vape",
      "disposable",
      "elfbar",
      "tugbot",
      "instabar",
      "al fakher vape"
    ],

    collections: [
      {
        name: "Vape",
        url: "/collections/vape"
      },

      {
        name: "ELFBAR",
        url: "/collections/elfbar"
      },

      {
        name: "TUGBOT",
        url: "/collections/tugbot"
      },

      {
        name: "INSTABAR",
        url: "/collections/instabar"
      }
    ]
  }

};

const customsLinks = {

  usa: {
    name: "United States",

    links: [
      {
        title: "US Customs and Border Protection",
        url: "https://www.help.cbp.gov/s/article/Article-1376?language=en_US"
      },

      {
        title: "FDA Tobacco Import Guide",
        url: "https://www.fda.gov/industry/importing-fda-regulated-products/importing-tobacco-products"
      }
    ]
  },

  germany: {
    name: "Germany",

    links: [
      {
        title: "German Customs Tobacco Rules",
        url: "https://www.zoll.de/EN/Private-individuals/Travel/Entering-Germany/Duties-and-taxes/Restricted-allowances/restricted-allowances_node.html"
      }
    ]
  },

  poland: {
    name: "Poland",

    links: [
      {
        title: "European Union Tobacco Rules",
        url: "https://europa.eu/youreurope/citizens/travel/carry/alcohol-tobacco-cash/index_en.htm"
      }
    ]
  },

  canada: {
    name: "Canada",

    links: [
      {
        title: "Canada Border Services Agency",
        url: "https://www.cbsa-asfc.gc.ca/travel-voyage/bring-apporter-eng.html"
      }
    ]
  },

  australia: {
    name: "Australia",

    links: [
      {
        title: "Australian Border Force",
        url: "https://www.abf.gov.au/"
      },

      {
        title: "Australia Vaping Regulations",
        url: "https://www.tga.gov.au/products/unapproved-therapeutic-goods/vaping-hub"
      }
    ]
  },

  newzealand: {
    name: "New Zealand",

    links: [
      {
        title: "New Zealand Customs",
        url: "https://www.customs.govt.nz/"
      },

      {
        title: "New Zealand Vaping Rules",
        url: "https://vapingfacts.health.nz/"
      }
    ]
  },

  qatar: {
    name: "Qatar",

    links: [
      {
        title: "Qatar Customs Authority",
        url: "https://www.customs.gov.qa/english/"
      }
    ]
  },

  kuwait: {
    name: "Kuwait",

    links: [
      {
        title: "Kuwait Customs",
        url: "https://www.customs.gov.kw/"
      }
    ]
  },

  bahrain: {
    name: "Bahrain",

    links: [
      {
        title: "Bahrain Customs Affairs",
        url: "https://www.bahraincustoms.gov.bh/"
      }
    ]
  },

  saudi: {
    name: "Saudi Arabia",

    links: [
      {
        title: "Saudi ZATCA Customs",
        url: "https://zatca.gov.sa/en/pages/default.aspx"
      }
    ]
  },

  india: {
    name: "India",

    links: [
      {
        title: "Indian Customs",
        url: "https://www.cbic.gov.in/"
      }
    ]
  },

  uk: {
    name: "United Kingdom",

    links: [
      {
        title: "UK Government Tobacco & Customs Rules",
        url: "https://www.gov.uk/bringing-goods-into-uk-personal-use/arriving-in-Great-Britain"
      }
    ]
  }

};